import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

const formatPrice = (price) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(price);

export default function ProductCard({ product }) {
  const getStartingPrice = () => {
    if (product.sizes && product.sizes.length > 0) {
      const prices = product.sizes.map(s => s.price).filter(p => typeof p === 'number');
      if (prices.length > 0) {
        return Math.min(...prices);
      }
    }
    return product.base_price || 0;
  };

  return (
    <Link to={`/producto/${product.id}`} data-testid={`product-card-${product.id}`}>
      <Card className="product-card group overflow-hidden border border-[#e5dfd3] bg-[#fcfbf9] hover:shadow-md transition-shadow rounded-2xl">
        <div className="aspect-square overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            className="product-card-img w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="p-4 sm:p-5">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h3 className="font-heading text-lg sm:text-xl font-semibold text-[#46371c] leading-tight">{product.name}</h3>
            {product.is_popular && (
              <Badge className="bg-[#a0d5ba]/20 text-[#46371c] border-[#a0d5ba] text-xs shrink-0">Popular</Badge>
            )}
          </div>
          <p className="font-body text-sm text-[#75664d] line-clamp-2 mb-3">{product.description}</p>
          <div className="flex items-center justify-between">
            <span className="font-body text-lg font-semibold text-[#46371c]">Desde {formatPrice(getStartingPrice())}</span>
            {product.preparation_days === 0 && (
              <Badge className="bg-[#a0d5ba] text-[#46371c] border-0 text-xs">Hoy</Badge>
            )}
          </div>
        </div>
      </Card>
    </Link>
  );
}

export { formatPrice };
